import { COMMON_BASE_URL_PREFIX } from '@flowwai-frontend/shared/constants'

export const imageUrls = {
   markLocation: `${COMMON_BASE_URL_PREFIX}/icons/mark-location.svg`,
   mapBg: `${COMMON_BASE_URL_PREFIX}/images/map-bg.png`,
   mapSatellitePreview: `${COMMON_BASE_URL_PREFIX}/images/map-satellite-perview.png`,
   mapSatellitePreviewV2: `${COMMON_BASE_URL_PREFIX}/images/mapSatellitePreviewV2.png`,
   mapStreetPreview: `${COMMON_BASE_URL_PREFIX}/images/map-street-preview.png`,
   mapStreetPreviewV2: `${COMMON_BASE_URL_PREFIX}/images/map-street-preview-v2.png`,
   mapMarker: `${COMMON_BASE_URL_PREFIX}/images/map-marker.png`,
   mapMarkerDot: `/assets/images/mark-location-dot.png`,
   markerCursor: `/assets/images/marker-cursor.png`,
   markerCursorSatellite: `/assets/images/marker-cursor-satellite.png`,
   openInGMapsPreview: `/assets/images/g-maps-preview.png`,
   markLocationPopupImage: '/assets/images/maps-marking-help.gif'
}
